var searchParamsToMessageFilter = function (searchParams) { return ({
    chatId: searchParams.get('chatId') || undefined,
    query: searchParams.get('query') || undefined,
    role: searchParams.getAll('role'),
    since: searchParams.get('since') || undefined,
    sort: searchParams.get('sort') === 'desc' ? 'desc' : undefined,
    to: searchParams.get('to') || undefined,
    userId: searchParams.get('userId') || undefined
}); };
export default searchParamsToMessageFilter;
